import styled, { css } from 'styled-components/macro';

export const VisitorRow = styled.tr<{ signedOut: boolean }>`
  ${({ signedOut }) =>
    signedOut &&
    css`
      background: lightgray;
    `};
`;

export const VisitorCard = styled.div<{ signedOut: boolean }>`
  /*align-items: center;*/
  background-color: white;
  border: 1px solid lightgrey;
  border-radius: 4px;
  border-left: 15px solid
    ${({ signedOut }) => (signedOut ? '#d6d6d6' : '#4da07d')};
  cursor: pointer;
  display: flex;
  /*justify-content: space-between;*/
  margin-bottom: 1rem;
  padding: 1rem;
  width: 100%;
  height: 100%;
`;

export const AvatarColumn = styled.div``;

export const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 1rem;
  width: 100%;
`;

export const Avatar = styled.div`
  border-radius: 50%;
  background: lightgrey;
  color: #585858;
  height: 68px;
  width: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BadgeContainer = styled.div`
  border-top: 1px solid lightgrey;
  display: flex;
  margin-top: 1rem;
  padding-top: 1rem;
`;

export const Badge = styled.div`
  background: #eff0f4;
  border-radius: 50%;
  color: #7a7676;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  margin-right: 6px;
`;

export const VisitorName = styled.div`
  font-size: 1.3rem;
  font-weight: 400;
`;

export const CompanyName = styled.div`
  font-weight: 300;
`;

export const CarRegistration = styled.small`
  display: block;
  position: absolute;
  bottom: 22px;
`;

export const ButtonContainer = styled.div`
  background-color: white;
  border: 1px solid lightgrey;
  margin-bottom: 1rem;
  padding: 1rem;
`;

export const LeftColumn = styled.div`
  @media only screen and (min-width: 768px) {
    display: flex;

    .form-group {
      flex: 1;
      width: 100%;
    }

    .form-group:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

export const RightColumn = styled.div`
  a,
  button {
    display: block;
    margin-bottom: 0.5rem;
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    display: flex;

    button,
    a {
      margin-bottom: 0;
      width: auto;
    }

    button,
    a:not(:last-child) {
      margin-right: 0.5rem;
    }
  }
`;
